import { render, staticRenderFns } from "./LastWeeksChart.vue?vue&type=template&id=2cdbeca6&scoped=true"
import script from "./LastWeeksChart.vue?vue&type=script&lang=js"
export * from "./LastWeeksChart.vue?vue&type=script&lang=js"
import style0 from "./LastWeeksChart.vue?vue&type=style&index=0&id=2cdbeca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbeca6",
  null
  
)

export default component.exports